import { catalogMediaAliases } from "../constants/catalog-media-aliases";

/** Resolve media for rendering only. Never mutate API objects or saved tool payloads. */
export function resolveMediaUrl(value: unknown, configuredBase?: string): string | undefined {
  if (typeof value !== "string" || !value.trim()) return undefined;
  const path = value.trim();
  if (/^data:image\/(png|jpeg|gif|webp|svg\+xml);/i.test(path) || /^blob:https?:\/\//i.test(path)) return path;
  // Reject control characters rather than allowing the URL parser to discard them.
  // eslint-disable-next-line no-control-regex
  if (/[\\\u0000-\u001f]/.test(path) || /^(undefined|null)(?:\/|$)/i.test(path)) return undefined;
  try {
    if (/^https?:\/\//i.test(path)) {
      const absolute = new URL(path);
      if (absolute.username || absolute.password || /^\/api(?:\/|$)/i.test(absolute.pathname)) return undefined;
      return path;
    }
    if (/^[a-z][a-z\d+.-]*:/i.test(path) || path.startsWith("//")) return undefined;
    decodeURI(path); // Reject malformed percent escapes before URL normalization.
    const normalized = "/" + path.replace(/^\/+/, "").replace(/\/{2,}/g, "/");
    if (normalized.split("/").some(part => part === ".." || part === ".") || /^\/api(?:\/|$)/i.test(normalized)) return undefined;
    const existingIcon = catalogMediaAliases[normalized];
    if (existingIcon) return existingIcon;
    const base = configuredBase || process.env.REACT_APP_MEDIA_IP || process.env.REACT_APP_ICONS_URI || process.env.REACT_APP_BACKEND_IP || window.location.origin;
    const origin = new URL(base);
    if (!/^https?:$/.test(origin.protocol) || origin.username || origin.password) return undefined;
    const resolved = new URL(normalized, origin.origin);
    if (/^\/api(?:\/|$)/i.test(resolved.pathname)) return undefined;
    return resolved.href;
  } catch {
    return undefined;
  }
}
